import React from 'react';
import { Design } from '../lib/FL';
import BusinessSwitch from '../components/designs/BusinessSwitch';
import DesignCard from '../components/designs/DesignCard';
import styles from './DesignsPage.module.scss';

type Props = {
  designs?: Design[];
};

const DesignsPage: React.FC<Props> = ({ designs }) => (
  <main className={styles.design}>
    <BusinessSwitch />
    <p className={styles.design__note}>※以下はトップページのみの画像サンプルです。</p>
    <ul className={styles.cards}>
      {designs?.map((design) => (
        <DesignCard design={design} key={design.type} />
      ))}
    </ul>
  </main>
);
DesignsPage.defaultProps = {
  designs: undefined,
};

export default DesignsPage;
